(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ai-doctor-phone-mockup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class AiPhoneSlideshow extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.ai-phone__scroll-track');
        this.slides = Array.from(this.querySelectorAll('.ai-phone__slide'));
        this.copySlides = Array.from(this.querySelectorAll('.ai-phone__copy-slide'));
        this.ctas = Array.from(this.querySelectorAll('.ai-phone__cta'));
        if (!this.track || this.slides.length === 0) return;

        this.onCtaPointerDown = this.onCtaPointerDown.bind(this);
        this.ctas.forEach((cta) => cta.addEventListener('pointerdown', this.onCtaPointerDown));

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.onScroll = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        if (typeof ResizeObserver !== 'undefined') {
          this.resizeObserver = new ResizeObserver(this.onScroll);
          this.resizeObserver.observe(this.track);
        }
        this.onScroll();
      }

      disconnectedCallback() {
        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
          this.resizeObserver = null;
        }
        if (this.ctas) {
          this.ctas.forEach((cta) => cta.removeEventListener('pointerdown', this.onCtaPointerDown));
        }
        if (!this.onScroll) return;
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }

      onCtaPointerDown(event) {
        const cta = event.currentTarget;
        cta.classList.add('is-touching');
        window.clearTimeout(cta.aiTouchTimer);
        cta.aiTouchTimer = window.setTimeout(() => {
          cta.classList.remove('is-touching');
        }, 1400);
      }

      onScroll() {
        const rect = this.track.getBoundingClientRect();
        const trackH = this.track.offsetHeight;
        const viewH = window.innerHeight;
        const total = Math.max(trackH - viewH, 1);
        const scrolled = Math.min(Math.max(-rect.top, 0), total);
        const progress = scrolled / total;

        const sectionEl = this.closest('section');
        if (sectionEl) {
          sectionEl.style.setProperty('--ai-scroll-progress', String(progress));
          const wave = Math.sin(progress * Math.PI * 2);
          const counterWave = Math.cos(progress * Math.PI * 2);
          sectionEl.style.setProperty('--ai-orb-a-x', `${18 + progress * 22}%`);
          sectionEl.style.setProperty('--ai-orb-a-y', `${14 + wave * 8}%`);
          sectionEl.style.setProperty('--ai-orb-b-x', `${82 - progress * 18}%`);
          sectionEl.style.setProperty('--ai-orb-b-y', `${24 + counterWave * 10}%`);
          sectionEl.style.setProperty('--ai-orb-c-x', `${18 + counterWave * 12}%`);
          sectionEl.style.setProperty('--ai-orb-c-y', `${58 + progress * 18}%`);
          sectionEl.style.setProperty('--ai-orb-d-x', `${78 - wave * 10}%`);
          sectionEl.style.setProperty('--ai-orb-d-y', `${78 - progress * 16}%`);
          sectionEl.style.setProperty('--ai-orb-scale', String(1 + progress * 0.18 + Math.abs(wave) * 0.08));
          sectionEl.style.setProperty('--ai-orb-rotate', `${progress * 18 - 9}deg`);
          sectionEl.style.setProperty('--ai-orb-counter-rotate', `${(progress * 18 - 9) * -0.75}deg`);
          sectionEl.style.setProperty('--ai-orb-blur', `${18 + Math.abs(counterWave) * 16}px`);
          sectionEl.style.setProperty('--ai-orb-opacity', String(0.72 + Math.abs(wave) * 0.24));
        }

        const n = this.slides.length;
        const active = n <= 1 ? 0 : Math.min(n - 1, Math.floor(progress * n));

        this.slides.forEach((slide, i) => {
          slide.style.opacity = n <= 1 ? '1' : i === active ? '1' : '0';
        });

        this.copySlides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === active);
        });
      }
    }

    if (!customElements.get('ai-phone-slideshow')) {
      customElements.define('ai-phone-slideshow', AiPhoneSlideshow);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    var priceDropBar = document.querySelector('.dt-price-drop-bar');
    if (!priceDropBar) return;

    var announcementMessages = Array.from(priceDropBar.querySelectorAll('[data-dt-announcement-message]'));
    var activeAnnouncement = Math.max(0, announcementMessages.findIndex(function(message) {
      return message.classList.contains('is-active');
    }));
    var announcementTimeout;
    announcementMessages.forEach(function(message) {
      var copy = message.querySelector('[data-nv-ann-copy]');
      if (!copy) return;
      var copies = JSON.parse(message.getAttribute('data-announcement-copies') || '[]');
      if (!copies.length) return;
      var copyIndex = 0;
      copy.parentElement.addEventListener('animationiteration', function(event) {
        if (event.animationName !== 'nv-ann-copy') return;
        copyIndex = (copyIndex + 1) % copies.length;
        copy.textContent = copies[copyIndex];
      });
      priceDropBar.addEventListener('dt:announcement-change', function(event) {
        if (event.detail !== message) return;
        copyIndex = 0;
        copy.textContent = copies[0];
      });
    });

    function showAnnouncement(index) {
      announcementMessages.forEach(function(message, messageIndex) {
        var isActive = messageIndex === index;
        message.classList.toggle('is-active', isActive);
        message.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        message.tabIndex = isActive ? 0 : -1;
      });
      activeAnnouncement = index;
      priceDropBar.dispatchEvent(new CustomEvent('dt:announcement-change', {
        detail: announcementMessages[index]
      }));
    }

    function scheduleAnnouncement() {
      window.clearTimeout(announcementTimeout);
      if (announcementMessages.length < 2) return;
      var duration = parseInt(announcementMessages[activeAnnouncement].getAttribute('data-rotation-duration'), 10) || 6000;
      announcementTimeout = window.setTimeout(function() {
        showAnnouncement((activeAnnouncement + 1) % announcementMessages.length);
        scheduleAnnouncement();
      }, duration);
    }

    if (announcementMessages.length > 1) {
      showAnnouncement(activeAnnouncement);
      scheduleAnnouncement();
    }

  })();

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.trans = this.dataset.trans;
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headersub = document.querySelector('.header-wrapper');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();

      this.headerResizeObserver = new ResizeObserver(() => this.setHeaderHeight());
      this.headerResizeObserver.observe(this.header);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.onScroll();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.getBoundingClientRect().height}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.headerResizeObserver.disconnect();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Add glassy blur effect when scrolled
      if (scrollTop > 50) {
        this.header.classList.add('scrolled');
      } else {
        this.header.classList.remove('scrolled');
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom || scrollTop > this.header.offsetHeight ) {
      // if (scrollTop != 0) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom || scrollTop > this.header.offsetHeight ) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top || scrollTop < this.header.offsetHeight) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);










  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-feature-tab"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll(".tab-button");
  const tabs = document.querySelectorAll(".product-tab");

  tabButtons.forEach(button => {
    button.addEventListener("click", () => {
      const target = button.getAttribute("data-tab");
      const targetTab = document.getElementById(target);
      
      // If clicking already active tab, do nothing (or we could toggle, but tabs usually stay open)
      if (button.classList.contains("active")) return;

      // Reset all
      tabButtons.forEach(btn => {
        btn.classList.remove("active");
        btn.setAttribute("aria-selected", "false");
      });
      tabs.forEach(tab => tab.classList.remove("visible"));

      // Set active
      button.classList.add("active");
      button.setAttribute("aria-selected", "true");
      if (targetTab) {
        targetTab.classList.add("visible");
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
